import PersonIcon from "./PersonIcon";
import { isValidHttpUrl } from "../../utils/web3Utils/baseWeb3";
import joinStyles from "../../utils/joinStyles";

const baseStyles = [
    "flex",
    "items-center",
    "justify-center",
    "rounded-full",
    "border-[2px]",
    "border-solid",
    "border-blue-500",
];

const getVariants = (variant) => {
    const variants = {
        bigProfileIcon: joinStyles([...baseStyles, "h-[90px]", "w-[90px]", "lg:h-[42px]", "lg:w-[42px]"]),
        smallProfileIcon: joinStyles([...baseStyles, "h-[28px]", "w-[28px]", "min-[451px]:h-[42px]", "min-[451px]:w-[42px]"]),
    };
    return variants[variant] || variants.bigProfileIcon;
};

const ProfileIcon = (props) => {
    return (
        <div className={getVariants(props.variant)}>
            {props.currentAvatar ? (
                <img
                    className={"h-full w-full rounded-full"}
                    src={
                        isValidHttpUrl(props.currentAvatar)
                            ? props.currentAvatar
                            : `/static/images/profile_pictures/${props.currentAvatar}`
                    }
                    alt={`Avatar ${props.currentAvatar}`}
                />
            ) : (
                <PersonIcon />
            )}
        </div>
    );
};

export default ProfileIcon;
